
import React, { useState } from 'react';
import { Container } from "reactstrap"
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import loginApi from '../services/loginApi'
import moment from 'moment';
import { BsFillEnvelopeFill, BsFillLockFill, BsFillEyeFill, BsFillEyeSlashFill } from "react-icons/bs";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import useToken from './useToken';
import '../assests/css/Login.css';
import resendOtpApi from '../services/resendOtpApi';
 
const Login = () => {
    const history = useHistory();
    const [disButton, setDisButton] = useState(false)
    const [pswdIcon, setPswdIcon] = useState(false)
    const [pswdTxt, setPswdTxt] = useState("password")
    // const { token, setToken } = useToken("");

    const { register, handleSubmit, formState: { errors } } = useForm();

    const onSubmitVerificationOTP = () => {
       
      if(localStorage.getItem('verification')){
        var data = {
            "userId": localStorage.getItem('email_verification')
        }
      }else{
             var data = {
                 "userId": localStorage.getItem('email')
             }
            }
             resendOtpApi(data).then(res => {
               console.log("data", data);
   
               console.log("request",res)
               if (res.success === "true") { 
                   console.log("Verified successfully", res.data)
   
                   history.push({
                       pathname : '/verify-otp',
                       type : true
                   });
               }
               else {
                   // console.log("Verification failed", res)
                   toast.error("User Not Exist!")
               //    reset(register);
               }
           });
       }




    const onSubmit = data => {
        data.type = "I";
        // console.log("data", data)
        setDisButton(true);
        loginApi(data).then(res => {
         console.log("res", res)
         console.log("data",data)
            if (res.success === "true") {
             console.log("res", res)
            
          if (res.data.secureIDNeedsToBeValidated === "N") {
            //     //    console.log("heelo from if block",res.data.secureIDNeedsToBeValidated)
            toast.success("Successfully Login!")
            localStorage.setItem('userId', JSON.stringify(res.data.userId));
            localStorage.setItem('email', JSON.stringify(data.userId));
            localStorage.setItem('sToken', JSON.stringify(res.data.sToken));

            history.push('/dashboard')
        } else {
      //      console.log("heelo from else block",res.data.secureIDNeedsToBeValidated)
            localStorage.setItem('userId', JSON.stringify(res.data.userId));
            localStorage.setItem('email', JSON.stringify(data.userId));
            localStorage.setItem('sToken', JSON.stringify(res.data.sToken));
            localStorage.setItem('verification', "verification");
            localStorage.setItem('email_verification', data.userId);
            onSubmitVerificationOTP();
            history.push('/verify-otp')
        }     
           }
            else {
                if (res === "Not a Valid User ") {
                    toast.warning("User Not Exist!");
                }
                else if (res === "Not a Valid password") {
                    toast.warning("Incorrect Password!");
                }
                else {
                    toast.error("Login failed!");
                }
                setDisButton(false);
                setTimeout(function () {
                    window.location.reload();
                }, 2000)
            }
        });
        localStorage.setItem('start-date', moment().startOf('month').format('MM/DD/YYYY'))
        localStorage.setItem('end-date', moment().endOf("day").format('MM/DD/YYYY'))
    }

    return (
        <div className="maindiv" style={{ fontFamily: "Poppins" }}>
            <Container fluid={true} style={{ alignItems: "center", justifyContent: "center", display: "flex" }}>
                <div className="text-center bg-white middleDiv">
                    <div className="innerDiv rounded">
                        <img src="LocusB.png" alt="logo" className="logo" />
                        <div className="text-center mb-1 login-heading">
                            <h5><b>Log into your account</b></h5>
                        </div>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="py-2">
                                {/* Email input field */}
                                <div className="form-group input-group my-2 marginBottomErrorSpan">
                                    <div className="form-group input-group-prepend">
                                        <span className="form-group input-group-text icon-setting left-icons"><BsFillEnvelopeFill /></span>
                                    </div>
                                    <input className="form-control inputpad" type="email" placeholder="Enter your email address" {...register("userId", { required: true, maxLength: 50 })} />
                                    <span className="errorSpan">{errors.userId?.type === 'required' && "*Email is required"}</span>
                                </div>
                                {/* Password input field */}
                                <div className="form-group input-group my-2 marginBottomErrorSpan">
                                    <div className="form-group input-group-prepend">
                                        <span className="form-group input-group-text icon-setting left-icons"><BsFillLockFill /></span>
                                    </div>
                                    <input className="form-control inputpad pswd-input" type={pswdTxt} placeholder="Enter your password" {...register("passwd", { maxLength: 20, minLength: 8, required: true })} />
                                    <div className="form-group input-group-postpend">
                                        <span className="form-group input-group-text icon-setting right-icons">
                                            {pswdIcon ?
                                                <BsFillEyeFill onClick={e => { setPswdIcon(false); setPswdTxt("password") }} /> :
                                                <BsFillEyeSlashFill onClick={e => { setPswdIcon(true); setPswdTxt("text") }} />
                                            }
                                        </span>
                                    </div>
                                    <span className="errorSpan">{errors.passwd?.type === 'required' && "*Password is required"}</span>
                                </div>

                            </div>
                            <ToastContainer autoClose={2000} hideProgressBar />
                            <a href="#/forget-pwd"><h6 className="text-size">Forgot password?</h6></a>
                            <div className="btn-margin">
                                <button type="submit" disabled={disButton} className="btnDesg my-2">
                                    {disButton ? <i className="bx bx-loader bx-spin font-size-24 align-middle me-2" /> : "Login"}
                                </button>
                            </div>
                            <small className="belowBtn">Don't have an account? <a href="#/signup" ><span><b>Sign up</b></span></a></small>
                        </form>
                    </div>
                </div>
            </Container>
        </div>
    );
}

export default Login;